import { render, staticRenderFns } from "./OsSurveyStepIntroInfo.vue?vue&type=template&id=14939818&scoped=true"
import script from "./OsSurveyStepIntroInfo.vue?vue&type=script&lang=ts"
export * from "./OsSurveyStepIntroInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14939818",
  null
  
)

export default component.exports